import { BillingInfoType } from '@sdk/account/api/AccountApi';
import { SUBSCRIPTION_BILLING_CYCLES } from '@sdk/account/constants';

import PurchaseView, {
  Props as PurchaseProps,
} from '@web/account/purchase/PurchaseView/PurchaseView';
import { BillingInfoProvider } from '@web/account/billing/BillingInfoContext';
import { PurchaseContextProvider } from '@web/account/purchase/PurchaseProvider/PurchaseProvider';

type Props = {
  initialLevel: number;
  billingInfo: BillingInfoType;
  initialBillingCycle: SUBSCRIPTION_BILLING_CYCLES;
} & PurchaseProps;

const PurchaseViewAngular = (props: Props) => {
  const { initialLevel, isOldPremium, billingInfo, initialBillingCycle, ...restProps } = props;

  return (
    <BillingInfoProvider billingInfo={billingInfo}>
      <PurchaseContextProvider
        initialLevel={initialLevel}
        initialBillingCycle={initialBillingCycle}
        isOldPremium={isOldPremium}>
        <PurchaseView isOldPremium={isOldPremium} {...restProps} />
      </PurchaseContextProvider>
    </BillingInfoProvider>
  );
};

export default {
  ReactComponent: PurchaseViewAngular,
  bindings: {
    initialLevel: '<',
    initialBillingCycle: '<',
    billingInfo: '<',
    currentUser: '<',
    subscriptionUtils: '<',
    currency: '<',
    postSubscriptionPurchase: '<',
    areYearlySubscriptionsEnabled: '<',
    isOldPremium: '<',
  },
};
